import styled, { StyledProps } from 'styled-components'
import { sv } from '@ucheba/utils/helpers/styles/variables'
import { mathVars, sm } from '@ucheba/utils/helpers/styles/mixins'
import { EModOpen, IModOpen } from '@ucheba/utils/helpers/styles/mod.types'

const Activator = styled.div`
  cursor: pointer;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: ${sv.spacing.large};
  padding-bottom: ${sv.spacing.large};
`

const Icon = styled.svg`
  width: 32px;
  height: 32px;
  flex-shrink: 0;
`

interface IInnerProps {
  marginLeft: number
}

const Inner = styled.div<StyledProps<IModOpen & IInnerProps>>`
  display: none;
  margin-top: -${mathVars(sv.spacing.large, '-', sv.spacing.xsmall)};
  padding-bottom: ${sv.spacing.large};
  margin-left: ${(props) => `${props.marginLeft}px`};
  ${sm.resetLastMb};

  ${sm.mod(EModOpen.true)`
    display: block;
  `};
`

const Block = styled.div`
  border-bottom: 1px solid ${sv.color.gray9};

  &:first-child {
    border-top: 1px solid ${sv.color.gray9};
  }
`

export default { Block, Inner, Activator, Icon }
